import axiosInstance from "./axiosInstance";

type CxbUserForgotPasswordProps = {
  email: string;
  password: string;
  confirmPassword: string;
};

const cxbUserForgotPassword = async (payload: CxbUserForgotPasswordProps) => {
  try {
    const { data } = await axiosInstance.post(
      "/cxbUserForgotPassword",
      payload,
    );
    return data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error("Failed to update password. Please try again.");
  }
};

export default cxbUserForgotPassword;
